import { Button } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from './AddNewButton.module.css';

const AddNewButton = ({
  buttonText = 'Add',
  clickHandler = () => {},
  disabled = false,
  miniVersion = false,
}) => {
  return (
    <Button
      minimal
      small={miniVersion}
      className={`${styles.add_button} ${disabled ? styles.disabled : ''}`}
      icon={'plus'}
      onClick={clickHandler}
      disabled={disabled}>
      {!miniVersion && buttonText}
    </Button>
  );
};

AddNewButton.propTypes = {
  buttonText: PropTypes.string,
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  miniVersion: PropTypes.bool,
};

export default AddNewButton;
